export default {
      id: "shipment__pallet-usage",
      viewBox: "0 0 23 19",
      url: __webpack_public_path__ + "img/icons.svg#shipment__pallet",
      toString: function () {
        return this.url;
      }
    }